import { Injectable, Injector } from '@angular/core';
import { SuccessAlertDialogComponent } from '@components/dialogs/success-alert-dialog/success-alert-dialog.component';
import { environment } from '@environments/environment';
import { UserHelperService } from '@helpers/user-helper.service';
import { UserAttributesI } from '@interfaces/user.interface';
import { MatDialog } from '@node_modules/@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from '@node_modules/ngx-toastr';
import { SessionStorageService } from '@services/common/session-storage.service';
import { SocketOptions } from 'dgram';
import { io, ManagerOptions, Socket } from 'socket.io-client';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socketUrl = environment.OMNISMART_SOCKET_URL;
  public socket!: Socket;
  private socketOptions: Partial<ManagerOptions & SocketOptions> = {
    reconnection: true,
    timeout: 5000,
  };
  private muted = true;

  private static readonly HEADER_EXTERNAL_LOGIN_ID = 'x-external-login';
  private static readonly HEADER_USER_ID = 'x-user-id';
  private static readonly HEADER_SESSION_ID = 'x-session-id';
  private static readonly HEADER_CUSTOMER_ID = 'x-customer-id';
  private static readonly HEADER_ACCESS_LEVEL = 'x-access-level';

  constructor(
    public dialog: MatDialog,
    private sessionStorageService: SessionStorageService,
    private userHelperService: UserHelperService,
    private injector: Injector,
    // private readonly toastrService: ToastrService,
    private readonly translate: TranslateService
  ) {}

  public init() {
    const user = this.userHelperService.getUserAttributes() as UserAttributesI;
    if (!this.socket && user) {
      const suffix = this.socketUrl.endsWith('/') ? '' : '/';
      this.socket = io(this.socketUrl + suffix, {
        ...this.socketOptions,
        extraHeaders: {
          [SocketService.HEADER_EXTERNAL_LOGIN_ID]: user.admin_user ? 'true' : 'false',
          [SocketService.HEADER_USER_ID]: user['custom:userId'],
          [SocketService.HEADER_CUSTOMER_ID]: user['custom:customer'],
          [SocketService.HEADER_ACCESS_LEVEL]: user.level?.toString() || '0',
          [SocketService.HEADER_SESSION_ID]: this.sessionStorageService.getSessionId()!,
        },
      });
      this.socket.connect();
      //Caso o socket tenha perdido a conexão e consiga recuperar em algum momento, atualizaz a tela para
      // garantir que o usuário esteja com as informações atualizadas
      this.socket.io.on('reconnect', () => {
        const toastrService = this.injector.get(ToastrService);
        toastrService.info(this.translate.instant('RECONNECTED_MESSAGE'), undefined, { closeButton: true });
      });
    }

    return this.socket;
  }

  public mute() {
    this.muted = true;
  }

  public restart() {
    if (this.socket) {
      this.socket.close();
      this.socket.connect();
    }

    return this.socket;
  }
}
